import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { getDatasourceType } from '@atlaskit/editor-common/utils';
import { showDatasourceModal } from '../pm-plugins/actions';
export var editDatasource = function editDatasource(datasourceId, editorAnalyticsApi, appearance, extensionKey) {
  return function (state, dispatch) {
    var datasourceType = getDatasourceType(datasourceId);
    if (dispatch && datasourceType) {
      var tr = state.tr;
      showDatasourceModal(datasourceType)(tr);
      editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
        action: ACTION.CLICKED,
        actionSubject: ACTION_SUBJECT.BUTTON,
        actionSubjectId: ACTION_SUBJECT_ID.EDIT_DATASOURCE,
        eventType: EVENT_TYPE.UI,
        attributes: {
          extensionKey: extensionKey,
          appearance: appearance
        }
      })(tr);
      dispatch(tr);
      return true;
    }
    return false;
  };
};